import { useState } from "react";
import QRCodeDisplay from "../../../components/QRCodeDisplay";
import AddressFlow from "../../../components/AddressFlow";
import { useHost } from "../../../hooks/userInfoService";
import { useLoad } from "../../../hooks/useLoad";
import { qrBaseUrl } from "../../../Endpoint";
import { useOwnerRestaurantSelection } from "../../../hooks/useOwnerRestaurantSelection";
import { useUser } from "../../../hooks/useUser";

export const Qrpage = () => {
    const { infoHost, updateRestoWork } = useHost();
    const { isOwner, userId } = useUser();
    const { selectedOwnerRestaurantId, selectedOwnerRestaurant } = useOwnerRestaurantSelection();
    const { load } = useLoad();
    const [isQr, setIsQr] = useState(true);
    const handleUpdate = () => {
        setIsQr(!isQr);
    }

    const handlePlaceSelected = async ({ name, formatted_address, country, place_id }) => {
        await updateRestoWork({ name, formatted_address, country, place_id });
        await load();
        setIsQr(true);
    }

    if (!isQr) {
        return <AddressFlow canceUpdate={handleUpdate} onPlaceSelected={handlePlaceSelected} />
    }

    const qrTargetId = isOwner
        ? userId || selectedOwnerRestaurantId || selectedOwnerRestaurant?._id || selectedOwnerRestaurant?.id || selectedOwnerRestaurant?.place_id || selectedOwnerRestaurant?.restoId
        : infoHost?._id;
    const qrName = isOwner
        ? selectedOwnerRestaurant?.name || "almacen"
        : infoHost?.name;

    return <>
        {qrTargetId && <QRCodeDisplay
            text={`${qrBaseUrl}/w/${qrTargetId}`}
            userName={qrName}
            onUpdate={handleUpdate}
            sizeCm={3}
            showUpdateButton={false}
        />}
    </>
}   
